export default "/assets/89dddd59a87bed59.svg"